import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllVehicle, getItemVehiclesMaintenances} from "../../../redux/vehicles";
import Card from "../../../components/card";
import Input from "../../../components/input";
import Modal from "../../../components/modal";
import {
    clear_log_mileage_vehicle,
    CREATE_LOG_MILEAGE_VEHICLE,
    createLogMileageVehicle, getMileageVehicle, UPDATE_LOG_MILEAGE_VEHICLE, updateLogMileageVehicle,
} from "../../../redux/log_mileage_vehicle";
import Button from "../../../components/button";
import {get_status, URLAPI} from "../../../config";
import {getAllMaintenanceSupplier} from "../../../redux/maintenance_supplier";
import SelectInput from "../../../components/select";
import {getAllVehicleMaintenance} from "../../../redux/vehicle_maintenance";
import {
    clear_item_vehicle_maintenance,
    CREATE_ITEM_VEHICLE_MAINTENANCE,
    createItemVehicleMaintenance,
    UPDATE_ITEM_VEHICLE_MAINTENANCE,
    updateItemVehicleMaintenance,
    UPDATE_DATE_MAINTENANCE,
    itemVehicleMaintenanceUpdate,
    get_report,
    GET_REPORT,
} from "../../../redux/item_vehicle_maintenance";
import TextArea from "../../../components/text-area";
import {
    clear_novelty_vehicle_maintenance,
    CREATE_NOVELTY_VEHICLE_MAINTENANCE,
    createNoveltyVehicleMaintenance
} from "../../../redux/novelty_maintenance_vehicle";

const Vehicles = (props) => {
    const dispatch = useDispatch();

    const _get_all_vehicle = useSelector((state) => state.vehicle_module._get_all_vehicle);

    const _create_log_mileage_vehicle = useSelector((state) => state.log_mileage_vehicle_module._create_log_mileage_vehicle);
    const _update_log_mileage_vehicle = useSelector((state) => state.log_mileage_vehicle_module._update_log_mileage_vehicle);
    const _get_all_maintenance_supplier = useSelector((state) => state.maintenance_supplier_module._get_all_maintenance_supplier);
    const _get_all_vehicle_maintenance = useSelector((state) => state.vehicle_maintenance_module._get_all_vehicle_maintenance);
    
    const _create_item_vehicle_maintenance = useSelector((state) => state.item_vehicle_maintenance_module._create_item_vehicle_maintenance);
    const _update_item_vehicle_maintenance = useSelector((state) => state.item_vehicle_maintenance_module._update_item_vehicle_maintenance);
    const _update_date_maintenance = useSelector((state) => state.item_vehicle_maintenance_module._update_date_maintenance);

    const _create_novelty_vehicle_maintenance = useSelector((state) => state.novelty_vehicle_maintenance_module._create_novelty_vehicle_maintenance);

    const _get_report = useSelector((store) => store.item_vehicle_maintenance_module._get_report);

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [permisos, setPermisos] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalNovelty, setModalNovelty] = useState(false);
    const [modalMaintenance, setModalMaintenance] = useState(false);
    const [modalServices, setModalServices] = useState(false);
    const [modalValidate, setModalValidate] = useState(false);
    const [modalLogs, setModalLogs] = useState(false);
    const [modalDate, setModalDate] = useState(false);
    const [modalReport, setModalReport] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [datas, setDatas] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [maintenances, setMaintenances] = useState([]);
    const [mileage, setMileage] = useState('');
    const [image, setImage] = useState('');
    const [services, setServices] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [item, setItem] = useState({});
    const [logs, setLogs] = useState([]);
    const [dateMaintenance, setDateMaintenance] = useState('');
    const [value, setValue] = useState(0);
    const [invoice, setInvoice] = useState('');
    const [description, setDescription] = useState('');
    const [photo, setPhoto] = useState('');
    const [date_start, setDateStart] = useState('');
    const [date_end, setDateEnd] = useState('');
    const [idLog, setIdLog] = useState(0);

    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);
    const [countMaintenance, setCountMaintenance] = useState(0);
    const [HasMoreMaintenance, setHasMoreMaintenance] = useState(true);

    const _session_data = useSelector(
        (state) => state.users_module._session_data
    );

    useEffect(() => {
        dispatch(getAllVehicle(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        if (_get_all_vehicle && _get_all_vehicle.data && _get_all_vehicle.data.datos) {
            let array = [];
            if (_session_data.data.grupo_permiso.nombre === "JEFE DE ZONA") {
                array = _get_all_vehicle.data.datos.filter(x => x.activo === true && x.identificacion_empleado === _session_data.data.identificacion)
            } else {
                array = _get_all_vehicle.data.datos.filter(x => x.activo === true);
            }
            setDatas(array);
        }
    }, [_get_all_vehicle, _session_data]);

    useEffect(() => {
        if (_get_all_maintenance_supplier && _get_all_maintenance_supplier.data && _get_all_maintenance_supplier.data.datos) {
            let array = _get_all_maintenance_supplier.data.datos.filter(x => x.activo === true);
            setSuppliers(array);
        }
    }, [_get_all_maintenance_supplier]);

    useEffect(() => {
        if (_get_all_vehicle_maintenance && _get_all_vehicle_maintenance.data && _get_all_vehicle_maintenance.data.datos) {
            let array = _get_all_vehicle_maintenance.data.datos.filter(x => x.activo === true);
            setMaintenances(array);
        }
    }, [_get_all_vehicle_maintenance]);

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_vehicle.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_vehicle.data.datos.filter(element => {
            if (element.placa.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const loadFunc = () => {
        if (_get_all_vehicle.data.datos) {
            if (_get_all_vehicle.data.datos.length > count) {
                const ordenado = _get_all_vehicle.data.datos.sort((a, b) => {
                    return new Date(b.fecha_creacion + ' 00:00:00') - new Date(a.fecha_creacion + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const loadFuncMaintenance = () => {
        if (DataSelected.items.length > countMaintenance) {
            // const ordenado = DataSelected.items.sort((a, b) => {
            //     return new Date(b.fecha_mantenimiento + ' 00:00:00') - new Date(a.fecha_mantenimiento + ' 00:00:00');
            // });
            // setDataSelected([...DataSelected, ...ordenado.slice(countMaintenance, countMaintenance + 10)]);
            DataSelected.items = DataSelected.items.slice(countMaintenance, countMaintenance + 10);
            setCountMaintenance(countMaintenance + 10);
        }
        setHasMoreMaintenance(false);
    };

    const initSelect = {
        id: 0,
        placa: "",
        marca: "",
        modelo: "",
        anio: "",
        color: "",
        foto: "",
        kilometraje_actual: "",
        kilometraje_mantenimiento: "",
        kilometraje: "",
        empleado: {
            identificacion: "",
            nombre: "",
            correo: "",
            telefono: "",
            foto: "",
        },
        items: []
    };

    const [DataSelected, setDataSelected] = useState(initSelect);

    const initForm = {
        id_vehiculo: DataSelected.id,
        fecha_mantenimiento: "",
        id_proveedor: 0,
        id_mantenimiento: 0,
        observacion: '',
    };

    const [form, setForm] = useState(initForm);

    const handleChange = (e) => {
        if (e.target.name === "id_proveedor" || e.target.name === "id_mantenimiento") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const onItemClickListener = async (item) => {
        const response = await getItemVehiclesMaintenances(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_create_log_mileage_vehicle.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_log_mileage_vehicle(CREATE_LOG_MILEAGE_VEHICLE));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModal(false);
        } else if (_create_log_mileage_vehicle.status !== 0) {
            dispatch(clear_log_mileage_vehicle(CREATE_LOG_MILEAGE_VEHICLE));
            toast.error(_create_log_mileage_vehicle.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_log_mileage_vehicle, dispatch, DataSelected]);

    useEffect(() => {
        if (_update_log_mileage_vehicle.status === 200) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_log_mileage_vehicle(UPDATE_LOG_MILEAGE_VEHICLE));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModal(false);
        } else if (_update_log_mileage_vehicle.status !== 0) {
            dispatch(clear_log_mileage_vehicle(UPDATE_LOG_MILEAGE_VEHICLE));
            toast.error(_update_log_mileage_vehicle.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_log_mileage_vehicle, dispatch, DataSelected]);


    const handleSubmitLogMileage = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (mileage === '') {
            toast.error("Debe ingresar el kilometraje actual");
            setIsLoading(false);
            return;
        }
        if (image === '' && idLog === 0) {
            toast.error("Debe seleccionar la foto del kilometraje actual");
            setIsLoading(false);
            return;
        }

        let form = new FormData();
        form.set("kilometraje_actual", mileage);
        form.set("imagen", image);

        if (idLog === 0) {
            form.set("id_vehiculo", DataSelected.id);
            dispatch(createLogMileageVehicle(token, form));
        } else {
            dispatch(updateLogMileageVehicle(token, idLog, form));
        }
    }
    
    useEffect(() => {
        if (_create_item_vehicle_maintenance.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_item_vehicle_maintenance(CREATE_ITEM_VEHICLE_MAINTENANCE));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModalMaintenance(false);
        } else if (_create_item_vehicle_maintenance.status !== 0) {
            dispatch(clear_item_vehicle_maintenance(CREATE_ITEM_VEHICLE_MAINTENANCE));
            toast.error(_create_item_vehicle_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_item_vehicle_maintenance, dispatch, DataSelected]);


    const handleSubmitItemMaintenanceVehicle = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.id_mantenimiento === 0) {
            toast.error("Debe seleccionar el mantenimiento a realizar");
            setIsLoading(false);
            return;
        }
        if (form.fecha_mantenimiento === '') {
            toast.error("Debe seleccionar la fecha del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (form.id_proveedor === 0) {
            toast.error("Debe seleccionar el proveedor del mantenimiento");
            setIsLoading(false);
            return;
        }
        dispatch(createItemVehicleMaintenance(token, form));
    }

    function handleChangeItem(e, id) {
        if (id === 0) {
            const all = services.map((p) =>
              p.id !== id ? { ...p, realizado: e.target.checked } : p
            );
            setServices(all);
            setAllChecked(!allChecked);
        } else {
            const item = services.map((p) =>
              p.id === id ? { ...p, realizado: e.target.checked } : p
            );
            setServices(item);
        }
    }

    function handleChangeItemObservation(e, id) {
        const item = services.map((p) =>
          p.id === id ? { ...p, observacion: e.target.value } : p
        );
        setServices(item);
    }

    useEffect(() => {
        if (_update_item_vehicle_maintenance.status === 200) {
            toast.success(_update_item_vehicle_maintenance.data.mensaje);
            dispatch(clear_item_vehicle_maintenance(UPDATE_ITEM_VEHICLE_MAINTENANCE));
            onItemClickListener(DataSelected);
            setModalServices(false);
            setIsLoading(false);
        } else if (_update_item_vehicle_maintenance.status !== 0) {
            toast.error(_update_item_vehicle_maintenance.message);
            dispatch(clear_item_vehicle_maintenance(UPDATE_ITEM_VEHICLE_MAINTENANCE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_item_vehicle_maintenance, dispatch, DataSelected]);

    useEffect(() => {
        if (_update_date_maintenance.status === 200) {
            toast.success(_update_date_maintenance.data.mensaje);
            dispatch(clear_item_vehicle_maintenance(UPDATE_DATE_MAINTENANCE));
            onItemClickListener(DataSelected);
            setModalServices(false);
            setModalDate(false);
            setModalValidate(false);
            setIsLoading(false);
        } else if (_update_date_maintenance.status !== 0) {
            toast.error(_update_date_maintenance.message);
            dispatch(clear_item_vehicle_maintenance(UPDATE_DATE_MAINTENANCE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_date_maintenance, dispatch, DataSelected]);

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (value === 0) {
            toast.error("Debe ingresar el costo del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (!invoice) {
            toast.error("Debe seleccionar la factura");
            setIsLoading(false);
            return;
        }
        let form = new FormData();
        form.append('factura', invoice);
        form.append('valor', value);
        form.append('tipo', 'factura');
        form.append('servicios', JSON.stringify(services));
        dispatch(itemVehicleMaintenanceUpdate(token, item.id, form));
    }

    const handleSubmitDateMaintenance = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (dateMaintenance === '') {
            toast.error("Debe seleccionar la fecha del mantenimiento");
            setIsLoading(false);
            return;
        }
        dispatch(itemVehicleMaintenanceUpdate(token, item.id, {"fecha_mantenimiento": dateMaintenance, tipo: 'fecha'}))
    }

    const handleSubmitServiceItemMaintenanceVehicle = (e) => {
        e.preventDefault();
        if(!modalDate) {
            setIsLoading(true);
            if (mileage === '') {
                toast.error("Debe ingresar el  kilometraje de ejecución");
                setIsLoading(false);
                return;
            }
            if (image === '') {
                toast.error("Debe seleccionar la foto del kilometraje de ejecución");
                setIsLoading(false);
                return;
            }
            let form = new FormData();
            form.append('kilometraje_actual', mileage);
            form.append('imagen', image);
            dispatch(updateItemVehicleMaintenance(token, item.id, form))
        }
    }

    const logsMileageVehicles = async (id_vehicle) => {
        const params = '?id_vehiculo=' + id_vehicle;
        const response = await getMileageVehicle(token, params);
        if (response && response.data && response.data.datos) {
            setLogs(response.data.datos);
            setModalLogs(true);
        }
    }

    useEffect(() => {
        if (_create_novelty_vehicle_maintenance.status === 201) {
            toast.success("Novedad de mantenimiento creada correctamente");
            dispatch(clear_novelty_vehicle_maintenance(CREATE_NOVELTY_VEHICLE_MAINTENANCE));
            setModalNovelty(false);
            setIsLoading(false);
        } else if (_create_novelty_vehicle_maintenance.status !== 0) {
            toast.error(_create_novelty_vehicle_maintenance.message);
            dispatch(clear_novelty_vehicle_maintenance(CREATE_NOVELTY_VEHICLE_MAINTENANCE));
            setIsLoading(false);
        }
    }, [_create_novelty_vehicle_maintenance, dispatch]);

    const handleSubmitNovelty = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (description === '') {
            toast.error("Debe una descripción del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (photo === '') {
            toast.error("Debe una seleccionar una foto");
            setIsLoading(false);
            return;
        }
       dispatch(createNoveltyVehicleMaintenance(token, {"id_vehiculo": DataSelected.id, "descripcion": description, 'foto': photo}));
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_item_vehicle_maintenance(GET_REPORT));
            setModalReport(false);
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_item_vehicle_maintenance(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': date_start,
            'fecha_fin': date_end,
        }, token));

    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Vehículos"
                            items={[{label: "Mantenimientos (vehículos)", link: "/mantenimientos-vehiculares"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="content-area-wrapper" style={{margin: 0}}>
                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">
                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por placa"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                {permisos.filter(element => element.codigo === "generate_report_vehicle_maintenance").length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/>
                                                                            </h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={() => {
                                                                                setDateStart('');
                                                                                setDateEnd('');
                                                                                setModalReport(true);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.placa}
                                                                    subtitle={'Año: ' + item.anio}
                                                                    rightDescription={'Kilometraje actual: '+ item.kilometraje_actual}
                                                                    bulletType={"success"}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    <small>Marca: {item.marca}</small><br/>
                                                                                    <small>Modelo: {item.modelo}</small><br/>
                                                                                    <small>Color: {item.color}</small>
                                                                                </div>
                                                                                <div className="mail-items">
                                                                                    <small>Último mantenimiento: {item.kilometraje_mantenimiento}</small><br/>
                                                                                    <small>Recorrido actual: {item.kilometraje}</small>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}

                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.placa}
                                                    </h5>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={
                                                                    <>
                                                                        <div>
                                                                            <small>Kilometraje actual</small><br/>
                                                                            <h4>{DataSelected.kilometraje_actual}</h4><br/>
                                                                            <small>Último mantenimiento: {DataSelected.kilometraje_mantenimiento}</small><br/>
                                                                            <small>Recorrido actual: {DataSelected.kilometraje}</small>
                                                                        </div>
                                                                    </>
                                                                }
                                                                subtitle={
                                                                    <div className="col-12 d-flex justify-content-end">
                                                                        <Button
                                                                            text="Historial"
                                                                            onChange={() => {
                                                                                logsMileageVehicles(DataSelected.id);
                                                                            }}
                                                                            theme="danger"
                                                                            type="button"
                                                                            disabled={isLoading}
                                                                        />
                                                                        { permisos && permisos.filter(x => x.codigo === 'add_logsmileagevehicle').length > 0 &&
                                                                            <Button
                                                                                text="Agregar kilometraje actual"
                                                                                onChange={() => {
                                                                                    setMileage('');
                                                                                    setIdLog(0);
                                                                                    setModal(true);
                                                                                }}
                                                                                theme="warning"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                                classes="ml-1"
                                                                            />
                                                                        }
                                                                        { permisos && permisos.filter(x => x.codigo === 'create_novelty_vehicle_maintenance').length > 0 &&
                                                                            <Button
                                                                                text="Crear novedad"
                                                                                onChange={() => {
                                                                                    setDescription('');
                                                                                    setPhoto('');
                                                                                    setModalNovelty(true);
                                                                                }}
                                                                                theme="primary"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                                classes="ml-1"
                                                                            />
                                                                        }
                                                                    </div>
                                                                }
                                                                description={
                                                                    <div className="row">
                                                                        <div className="col-md-6 col-12">
                                                                            <h5>Vehículo</h5>
                                                                            <div className="mt-1 d-flex">
                                                                                <div className="text-center">
                                                                                    <img src={DataSelected.foto ? URLAPI + DataSelected.foto : window.location.origin+"/base/app-assets/images/profile/no_perfil.png"} width={150} alt="vehículo"/>
                                                                                </div>
                                                                                <div className="ml-2">
                                                                                    <strong>Placa: </strong>{DataSelected.placa}<br/>
                                                                                    <strong>Marca: </strong>{DataSelected.marca}<br/>
                                                                                    <strong>Modelo: </strong>{DataSelected.modelo}<br/>
                                                                                    <strong>Color: </strong>{DataSelected.color}<br/>
                                                                                    <strong>Año: </strong>{DataSelected.anio}
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 col-12">
                                                                            <h5>Empleado asignado</h5>
                                                                            <div className="mt-1 d-flex">
                                                                                <div className="text-center">
                                                                                    <img src={DataSelected.empleado.foto ? URLAPI + DataSelected.empleado.foto : window.location.origin+"/base/app-assets/images/profile/no_perfil.png"} width={150} alt="empleado"/>
                                                                                </div>
                                                                                <div className="ml-2">
                                                                                    <strong>Identificación: </strong>{DataSelected.empleado.identificacion}<br/>
                                                                                    <strong>Nombre: </strong>{DataSelected.empleado.nombre}<br/>
                                                                                    <strong>Correo: </strong>{DataSelected.empleado.correo}<br/>
                                                                                    <strong>Teléfono: </strong>{DataSelected.empleado.telefono}
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            >
                                                                <div className="row">
                                                                    <div className="col-md-6 col-12">
                                                                        <h6>Mantenimientos</h6>
                                                                    </div>
                                                                    <div className="col-md-6 col-12 text-right">
                                                                        { permisos && permisos.filter(x => x.codigo === 'add_itemsvehiclemaintenance').length > 0 &&
                                                                            <Button
                                                                                text="Crear mantenimiento"
                                                                                onChange={() => {
                                                                                    dispatch(getAllMaintenanceSupplier(token));
                                                                                    dispatch(getAllVehicleMaintenance(token));
                                                                                    setForm(initForm);
                                                                                    document.getElementById("id_mantenimiento").selectedIndex = 0;
                                                                                    document.getElementById("id_proveedor").selectedIndex = 0;
                                                                                    setModalMaintenance(true);
                                                                                }}
                                                                                theme="success"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <div className="email-app-area">
                                                                            <div className="email-app-list-wrapper">
                                                                                <div className="email-app-list">
                                                                                    <div className="email-user-list list-group mt-1">
                                                                                        <ul className="users-list-wrapper media-list" style={{
                                                                                            overflowY: 'scroll',
                                                                                        }}>
                                                                                            <InfiniteScroll
                                                                                                pageStart={0}
                                                                                                loadMore={() => loadFuncMaintenance()}
                                                                                                hasMore={HasMoreMaintenance}
                                                                                                useWindow={false}

                                                                                                loader={
                                                                                                    <div className="col-12 d-flex justify-content-center">
                                                                                                        <div
                                                                                                            className="spinner-border text-success"
                                                                                                            role="status"
                                                                                                        >
                                                                                                            <span className="sr-only">Loading...</span>
                                                                                                        </div>
                                                                                                        {" "}
                                                                                                    </div>
                                                                                                }
                                                                                            >
                                                                                                {DataSelected.items.map((item, index) => (
                                                                                                    <ItemList1
                                                                                                        item={item}
                                                                                                        title={item.mantenimiento}
                                                                                                        subtitle={item.fecha_mantenimiento}
                                                                                                        rightDescription={item.estado}
                                                                                                        bulletType={get_status(item.estado)}
                                                                                                        children={
                                                                                                            <>
                                                                                                                <div className="user-details div_fecha">
                                                                                                                    <div className="mail-items">
                                                                                                                        <span>Proveedor: {(item && item.proveedor) ? item.proveedor.nombre : ''}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        }
                                                                                                        onClick={(item) => {
                                                                                                            if (item.estado === "MANTENIMIENTO ACEPTADO" && permisos.filter(x => x.codigo === 'valid_vehicle_maintenance').length > 0) {
                                                                                                                let array = [];
                                                                                                                // eslint-disable-next-line
                                                                                                                item.servicios.map(s => {
                                                                                                                    array.push({
                                                                                                                        id: s.id,
                                                                                                                        servicio: s.servicio,
                                                                                                                        tipo: s.tipo,
                                                                                                                        realizado: false,
                                                                                                                        observacion: '',
                                                                                                                    })
                                                                                                                })
                                                                                                                setServices(array);
                                                                                                                setAllChecked(false);
                                                                                                                setValue(0);
                                                                                                                setInvoice('');
                                                                                                                setModalValidate(true);
                                                                                                            } else {
                                                                                                                setServices(item.servicios);
                                                                                                                setMileage('');
                                                                                                                setImage('');
                                                                                                                setModalServices(true);
                                                                                                            }
                                                                                                            setItem(item);
                                                                                                        }}
                                                                                                    />
                                                                                                ))}
                                                                                            </InfiniteScroll>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/*<div className="table-responsive">*/}
                                                                        {/*    <DataTable*/}
                                                                        {/*        dataTable={DataSelected.items}*/}
                                                                        {/*        columns={[*/}
                                                                        {/*            {*/}
                                                                        {/*                name: "fecha_mantenimiento",*/}
                                                                        {/*                label: "Fecha del mantenimiento",*/}
                                                                        {/*                type: "text",*/}
                                                                        {/*            },*/}
                                                                        {/*            {*/}
                                                                        {/*                name: "mantenimiento",*/}
                                                                        {/*                label: "Mantenimiento",*/}
                                                                        {/*                type: "text",*/}
                                                                        {/*            },*/}
                                                                        {/*            {*/}
                                                                        {/*                name: "estado",*/}
                                                                        {/*                label: "Estado",*/}
                                                                        {/*                type: "text",*/}
                                                                        {/*            },*/}
                                                                        {/*        ]}*/}
                                                                        {/*        actions={actions}*/}
                                                                        {/*    />*/}
                                                                        {/*</div>*/}
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modal}>
                <form onSubmit={handleSubmitLogMileage}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h6 className="titulo_modal">Kilometraje actual ({DataSelected.kilometraje_actual})</h6>
                        <div className="form-group mt-1">
                            <Input
                                label="Kilometraje actual"
                                name="mileage"
                                onChange={(e) => setMileage(e.target.value)}
                                value={mileage}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                name="imagen"
                                label="Foto"
                                type="file"
                                accept="image/*"
                                onChange={(e) => setImage(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalMaintenance}>
                <form onSubmit={handleSubmitItemMaintenanceVehicle}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Crear mantenimiento del vehículo</h5>
                        <div className="form-group">
                            <label>Mantenimiento</label>
                            <SelectInput
                                label="Mantenimiento"
                                id="id_mantenimiento"
                                name="id_mantenimiento"
                                options={maintenances.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                }))}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                 type="date"
                                name="fecha_mantenimiento"
                                label="Fecha de mantenimiento"
                                onChange={handleChange}
                                placeholder=""
                                value={form.fecha_mantenimiento}
                            />
                        </div>
                        <div className="form-group">
                            <label>Proveedor</label>
                            <SelectInput
                                label="Proveedor"
                                id="id_proveedor"
                                name="id_proveedor"
                                options={suppliers.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                }))}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Observación"
                                name="observacion"
                                onChange={handleChange}
                                rows={5}
                                value={form.observacion}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalMaintenance(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalServices} auto="200%">
                <form onSubmit={handleSubmitServiceItemMaintenanceVehicle}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col-12">
                                <h5>{item.mantenimiento}</h5>
                                <strong>Kilometraje actual</strong><br/>
                                <h5>{DataSelected.kilometraje_actual}</h5>
                            </div>
                            <div className="col-md-6 col-12">
                                {(item.estado === "MANTENIMIENTO PENDIENTE" && permisos.filter(x => x.codigo === 'change_date_vehicle_maintenance').length > 0) ?
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <strong>Fecha del mantenimiento</strong><br/>
                                            {item.fecha_mantenimiento}
                                        </div>
                                        <div className="col-md-6 col-12 text-right">
                                            <button className="btn btn-warning" onClick={(e) => {
                                                e.preventDefault();
                                                setDateMaintenance(item.fecha_mantenimiento);
                                                setModalServices(false);
                                                setModalDate(true);
                                            }}>Cambiar fecha</button>
                                        </div>
                                    </div>
                                :
                                    <>
                                        <strong>Fecha del mantenimiento</strong><br/>
                                        {item.fecha_mantenimiento}
                                    </>
                                }
                            </div>
                            <div className="col-md-6 col-12">
                                <strong>Proveedor</strong><br/>
                                {(item && item.proveedor) ? item.proveedor.nombre : ''} <br/>
                                {(item && item.proveedor) ? item.proveedor.correo : ''} <br/>
                                {(item && item.proveedor) ? item.proveedor.telefono : ''} <br/>
                                {(item && item.proveedor) ? item.proveedor.direccion : ''} <br/>
                            </div>
                            {item.kilometraje &&
                                <div className="col-md-6 col-12">
                                    <strong>Kilometraje de ejecución del mantenimiento</strong><br/>
                                    {item.kilometraje}
                                </div>
                            }
                            {item.valor &&
                                <div className="col-md-6 col-12">
                                    <strong>Valor del mantenimiento</strong><br/>
                                    $ {item.valor}
                                </div>
                            }
                            {item.factura &&
                                <div className="col-md-6 col-12">
                                    <h6>Factura</h6>
                                    {/*eslint-disable-next-line*/}
                                    <a href={`${URLAPI}${item.factura}`} target="_blank">
                                        <img
                                            className="logo"
                                            src="/base/app-assets/images/icon/pdf.png"
                                            alt="logo"
                                            style={{width: "100px",height: "auto", }}
                                        />
                                    </a>
                                </div>
                            }
                            {item.observacion &&
                                <div className="col-12">
                                    <strong>Observación</strong><br/>
                                    {item.observacion}
                                </div>
                            }
                        </div>
                        {(item.estado === "MANTENIMIENTO PENDIENTE" && permisos.filter(x => x.codigo === 'change_itemsvehiclemaintenance').length > 0) &&
                            <>
                                <div className="form-group">
                                    <Input
                                        label="Kilometraje de ejecución"
                                        name="mileage"
                                        onChange={(e) => setMileage(e.target.value)}
                                        value={mileage}
                                    />
                                </div>
                                <div className="form-group">
                                    <Input
                                        name="imagen"
                                        label="Foto"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setImage(e.target.files[0])}
                                    />
                                </div>
                            </>
                        }
                        <h5 className="titulo_modal mb-2">Servicios</h5>
                        <div className="form-group">
                            <table className="mt-1 table table-bordered">
                                <tr>
                                    <th className="text-center">Servicio</th>
                                    <th className="text-center">Tipo</th>
                                    <th className="text-center" style={{display: "grid"}}>
                                        <label>Ejecutado</label>
                                    </th>
                                    <th className="text-center">Observación (opcional)</th>
                                </tr>
                                {services.map((j, index) => (
                                    <tr>
                                        <td>{j.servicio}</td>
                                        <td>{j.tipo}</td>
                                        <td className="text-center">{j.realizado}</td>
                                        <td>{j.observacion}</td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        {(item.estado === "MANTENIMIENTO PENDIENTE" && permisos.filter(x => x.codigo === 'change_itemsvehiclemaintenance').length > 0) &&
                            <button disabled={isLoading} onClick={() => {
                            }} className={`btn btn-success button_div mt-1`}>Guardar
                            </button>
                        }
                        <button type="button" onClick={() => {
                            setModalServices(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalLogs} auto="160%">
                <div className="card-body">
                    <h5 className="titulo_modal mb-2">Historial de kilometraje</h5>
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-center">Fecha</th>
                                    <th className="text-center">Kilometraje</th>
                                    <th className="text-center">Foto</th>
                                    {permisos.filter(x => x.codigo === 'change_logsmileagevehicle').length > 0 &&
                                        <th className="text-center">Acciones</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log) => (
                                    <tr>
                                        <td>{log.fecha_creacion}</td>
                                        <td>{log.kilometraje}</td>
                                        <td className="text-center">
                                            {/*eslint-disable-next-line*/}
                                            <a href={`${URLAPI}${log.foto}`} target="_blank" className="btn btn-info">Ver foto</a>
                                        </td>
                                        {permisos.filter(x => x.codigo === 'change_logsmileagevehicle').length > 0 &&
                                            <td className="text-center">
                                                {/*eslint-disable-next-line*/}
                                                <a href="" onClick={(e) => {
                                                    e.preventDefault();
                                                    setIdLog(parseInt(log.id));
                                                    setMileage(log.kilometraje);
                                                    setImage('');
                                                    setModalLogs(false);
                                                    setModal(true);
                                                }}><i className="badge-circle badge-circle-light-primary bx bxs-edit"/></a>
                                            </td>
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="card-footer text-center">
                    <button type="button" onClick={() => {
                        setModalLogs(false);
                    }} className={`btn btn-outline-dark button_div`}>Cerrar
                    </button>
                </div>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalDate}>
                <form onSubmit={handleSubmitDateMaintenance}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Actualizar fecha de mantenimiento</h5>
                        <div className="form-group">
                            <Input
                                type="date"
                                name="fecha_mantenimiento"
                                label="Fecha de mantenimiento"
                                onChange={(e) => setDateMaintenance(e.target.value)}
                                placeholder=""
                                value={dateMaintenance}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalDate(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalValidate} auto="200%">
                <form onSubmit={handleUpdateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Validar</h5>
                        <div className="form-group">
                            <Input
                                label="Costo del mantenimiento"
                                name="valor"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Factura"
                                name="archivo"
                                type="file"
                                accept=".docx,.pdf"
                                onChange={(e) => setInvoice(e.target.files[0])}
                            />
                        </div>
                        <h5 className="titulo_modal mb-2">Servicios</h5>
                        <div className="form-group">
                            <table className="mt-1 table table-bordered">
                                <tr>
                                    <th className="text-center">Servicio</th>
                                    <th className="text-center">Tipo</th>
                                    <th className="text-center" style={{display: "grid"}}>
                                        <label>Ejecutado</label>
                                        <input id="all" className="form-check-input" type="checkbox" checked={allChecked} style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, 0)}/>
                                    </th>
                                    <th className="text-center">Observación (opcional)</th>
                                </tr>
                                {services.map((j, index) => (
                                    <tr>
                                        <td>{j.servicio}</td>
                                        <td>{j.tipo}</td>
                                        <td className="text-center">
                                            <input id={j.id} checked={j.realizado} className="form-check-input" type="checkbox" style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, j.id)}/>
                                        </td>
                                        <td className="text-center">
                                            <input style={{width: 180}} className="form-control" onChange={(e) => handleChangeItemObservation(e, j.id)}/>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Validar
                        </button>
                        <button type="button" onClick={() => {
                            setModalValidate(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalNovelty}>
                <form onSubmit={handleSubmitNovelty}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Crear novedad</h5>
                        <div className="form-group">
                            <TextArea
                                id="descripcion"
                                name="descripcion"
                                label="Descripción"
                                placeholder=""
                                onChange={(e) => setDescription(e.target.value)}
                                rows={4}
                                value={description}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Foto"
                                name="foto"
                                type="file"
                                accept="image/*"
                                onChange={(e) => setPhoto(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalNovelty(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalReport}>
                <form onSubmit={handleGenerateReport}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Generar reporte de mantenimientos de vehículos</h5>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha inicial"
                                onChange={(e) => setDateStart(e.target.value)}
                                value={date_start}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha final"
                                onChange={(e) => setDateEnd(e.target.value)}
                                value={date_end}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Generar
                        </button>
                        <button type="button" onClick={() => {
                            setModalReport(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Vehicles
